export function calculateAge(dateString: string | undefined): number | null {
  if (!dateString) return 0;
  // Check if the input date string is in the correct format
  const dateRegex = /^\d{2}-\d{2}-\d{4}$/;
  if (!dateRegex.test(dateString)) {
    console.error("Invalid date format. Please use dd/mm/yyyy.");
    return null;
  }

  // Parse the input date string into a Date object
  const parts = dateString.split("-");
  const day = parseInt(parts[0], 10);
  const month = parseInt(parts[1], 10) - 1; // Months are zero-based in JavaScript Date object
  const year = parseInt(parts[2], 10);
  const inputDate = new Date(year, month, day);

  // Get the current date
  const currentDate = new Date();

  // Calculate the age
  let age = currentDate.getFullYear() - inputDate.getFullYear();

  // Adjust the age based on the current month and day
  if (
    currentDate.getMonth() < inputDate.getMonth() ||
    (currentDate.getMonth() === inputDate.getMonth() &&
      currentDate.getDate() < inputDate.getDate())
  ) {
    age--;
  }

  return age;
}
